import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BillingCtx = createContext(null);

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  const refresh = useCallback(async () => {
    if (!user || user === false || user === null) { setStatus(null); return; }
    try {
      const { data } = await api.get("/billing/status");
      setStatus(data);
    } catch {
      setStatus(null);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ status, refresh }), [status, refresh]);

  return (
    <BillingCtx.Provider value={value}>
      {children}
    </BillingCtx.Provider>
  );
}

export const useBilling = () => useContext(BillingCtx) || { status: null, refresh: () => {} };
